package fr.frux.core.database

/** Pas de driver SQLite sur web à ce stade (cf. DatabaseDriverFactory.js) : cache désactivé. */
actual val localDatabaseSupported: Boolean = false
